import * as Yup from "yup";

export const dataModel = {
  courseUuid: "",
  farm: "",
  month: "",
};

export const validationDataModel = Yup.object().shape({
  courseUuid: Yup.string().optional(""),
  farm: Yup.string().optional(""),
  month: Yup.date().optional(""),

});

export const setInitialValues = (initialValues) => {
  const newValues = { ...dataModel };
  if (initialValues) {
    const items = Object.keys(newValues);
    items.forEach((item) => {
      if (initialValues[item]) {
        newValues[item] = initialValues[item];
      }
    });
    return newValues;
  }

  return dataModel;
};
